import { render, staticRenderFns } from "./CategoryWidget.vue?vue&type=template&id=c843556c&scoped=true"
import script from "./CategoryWidget.vue?vue&type=script&lang=js"
export * from "./CategoryWidget.vue?vue&type=script&lang=js"
import style0 from "./CategoryWidget.vue?vue&type=style&index=0&id=c843556c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c843556c",
  null
  
)

export default component.exports